import Vue from 'vue';
import VueRouter, {RouteConfig} from 'vue-router';
import Dashboard from '@pazion/pazion-core/src/views/Dashboard.vue';
import Login from '@pazion/pazion-core/src/views/user/Login.vue';
import Logout from '@pazion/pazion-core/src/views/user/Logout.vue';
import Profile from '@pazion/pazion-core/src/views/user/Profile.vue';
import LogsPage from '@pazion/pazion-core/src/views/logs/LogsPage.vue';
import QueueListing from "@pazion/pazion-core/src/views/queue/QueueListing.vue";
import UserListing from "@pazion/pazion-core/src/views/user/UserListing.vue";
import TenantListing from "@pazion/pazion-core/src/views/tenant/TenantListing.vue";
import UserEdit from "@pazion/pazion-core/src/views/user/UserEdit.vue";
import ForgotPassword from "@pazion/pazion-core/src/views/user/PasswordForget.vue";
import ActivateAccount from "@pazion/pazion-core/src/views/user/ActivateAccount.vue";
import PackagesVersionPage from "@pazion/pazion-core/src/views/packages/PackagesVersionPage.vue";
import DossierListingPage from "@pazion/pazion-core/src/views/dossier/DossierListingPage.vue"
import DossierCourseDialog from "@pazion/pazion-core/src/views/dossier/parts/pazDossierCoursePage.vue";
import SettingsPage from "@pazion/pazion-core/src/views/settings/SettingsPage.vue";
import GroupList from "@pazion/pazion-core/src/views/group/GroupList.vue";
import GroupDetailList from "@pazion/pazion-core/src/views/group/GroupDetailList.vue";
import RequiredCategoryOverview from "@pazion/pazion-core/src/views/dossier/requirements/RequiredCategoryOverview.vue";
import RequiredDocumentsOverview from "@pazion/pazion-core/src/views/dossier/requirements/RequiredDocumentsOverview.vue";
import {authentication} from "@pazion/pazion-core/src/store";
import ApiSettingsConfiguration from "@pazion/pazion-core/src/views/settings/ApiSettingsConfiguration.vue";
import Home from "@pazion/pazion-core/src/views/Home.vue";
import MessagePage from "@pazion/pazion-core/src/views/message/MessagePage.vue";
import PazionErrorPage from "@pazion/pazion-core/src/views/PazionErrorPage.vue";

Vue.use(VueRouter);

export const baseRoutes: RouteConfig[] = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            'show-in-nav': false,
            roles: ['user'],
            sort: -100
        },
    }, {
        path: '/',
        name: 'home',
        component: Home,
        meta: {
            'show-in-nav': false,
            roles: ['user'],
            sort: -100
        },
    }, {
        path: '/',
        name: 'dashboard',
        component: Dashboard,
        meta: {
            'show-in-nav': false,
            roles: ['user'],
            sort: -100
        },
    }, {
        path: '/error',
        name: 'error',
        component: PazionErrorPage,
        meta: {
            'show-in-nav': false,
            sort: -100,
            guest: true,
        },
    }, {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            guest: true,
        }
    }, {
        path: '/forgot-password/:token?',
        name: 'forgot-password',
        component: ForgotPassword,
        meta: {
            guest: true,
        }
    }, {
        path: '/activate-account/:token?',
        name: 'activate-account',
        component: ActivateAccount,
        meta: {
            guest: true,
        }
    },
    {
        path: '/dossier',
        name: 'dossier',
        component: DossierListingPage,
        meta: {
            'show-in-nav': true,
            profilePermission: 'dossierManagement.show',
            roles: ['user', 'customer'],
            sort: 700
        },
        children: []
    },
    {
        path: '/dossier/:dossierId',
        name: 'dossier-course-page',
        component: DossierCourseDialog,
        props: true,
        meta: {
            'show-in-nav': false,
            profilePermission: 'dossierManagement.show',
            roles: ['user']
        },
    },
    {
        path: '/dossier/order',
        name: 'DossierOrderFiles',
        component: DossierCourseDialog,
        meta: {
            'show-in-nav': false,
            profilePermission: 'dossierManagement.show',
            roles: ['user', 'customer']
        },
    }, {
        path: '',
        name: 'settings',
        component: SettingsPage,
        meta: {
            'show-in-nav': true,
            roles: ['administrator'],
            sort: 1000
        },
        children: [
            {
                path: '/queue',
                name: 'queue',
                component: QueueListing,
                meta: {
                    'show-in-nav': true,
                    profilePermission: 'queueManagement.show',
                    roles: ['administrator'],
                    'icon': 'mdi-cog-play',
                    sort: 800
                },
            },
            {
                path: '/logs',
                name: 'logs',
                component: LogsPage,
                meta: {
                    'show-in-nav': true,
                    profilePermission: 'logManagement.show',
                    roles: ['administrator'],
                    'icon': 'mdi-text-long',
                    sort: 900
                },
            }, {
                path: '/messages',
                name: 'messages',
                component: MessagePage,
                meta: {
                    'show-in-nav': true,
                    profilePermission: 'messageManagement.show',
                    roles: ['administrator'],
                    'icon': 'mdi-email-outline',
                    sort: 920
                },
            },
            {
                path: '/apisetting',
                name: 'packages',
                component: ApiSettingsConfiguration,
                meta: {
                    'show-in-nav': true,
                    profilePermission: 'packageManagement.show',
                    'hasDrawer': true,
                    'icon': 'mdi-package-variant-closed',
                    roles: ['administrator'],
                    sort: 1000
                },
            },
            {
                path: '/apisetting/:package?',
                name: 'package-edit',
                component: ApiSettingsConfiguration,
                meta: {
                    'show-in-nav': false,
                    profilePermission: 'packageManagement.show',
                    'hasDrawer': true,
                    'icon': 'mdi-package-variant-closed',
                    roles: ['administrator'],
                    sort: 1000
                },
            },
            {
                path: '/profile',
                name: 'profile',
                component: Profile,
                meta: {
                    'show-in-nav': true,
                    profilePermission: 'userManagement.profile',
                    'hasDrawer': true,
                    'icon': 'mdi-account',
                    roles: ['user', 'customer', 'production'],
                    sort: 100
                },
            },
            {
                path: '/users',
                name: 'users',
                component: UserListing,
                meta: {
                    'hasDrawer': true,
                    'show-in-nav': true,
                    profilePermission: 'userManagement.show',
                    'icon': 'mdi-account-multiple',
                    roles: ['administrator'],
                },
            },
            {
                path: '/tenants',
                name: 'Tenants',
                component: TenantListing,
                meta: {
                    'hasDrawer': true,
                    'show-in-nav': true,
                    profilePermission: 'tenantManagement.globalAdmin',
                    'icon': 'mdi-account-supervisor-circle-outline',
                    roles: ['administrator'],
                },
            },
            {
                path: '/users/:id',
                name: 'user-edit',
                component: UserEdit,
                props: true
            },
            {
                path: '/groups',
                name: 'group',
                component: GroupList,
                meta: {
                    'hasDrawer': false,
                    'show-in-nav': true,
                    profilePermission: 'groupManagement.show',
                    'icon': 'mdi-account-multiple',
                    roles: ['administrator'],
                },
            },
            {
                path: '/document-categories',
                name: 'document-categories',
                component: RequiredCategoryOverview,
                meta: {
                    'hasDrawer': false,
                    'show-in-nav': true,
                    'icon': 'mdi-account-multiple',
                    profilePermission: 'documentManagement.show',
                    roles: ['administrator'],
                },
            },
            {
                path: '/required-documents',
                name: 'required-documents',
                component: RequiredDocumentsOverview,
                meta: {
                    'hasDrawer': false,
                    'show-in-nav': true,
                    'icon': 'mdi-account-multiple',
                    profilePermission: 'documentManagement.show',
                    roles: ['administrator'],
                },
            },
            {
                path: '/groups/:id',
                name: 'group-edit',
                component: GroupDetailList,
                props: true
            },
            {
                path: '/package-versions',
                name: 'versions',
                component: PackagesVersionPage,
                meta: {
                    'show-in-nav': true,
                    profilePermission: 'versionManagement.show',
                    'hasDrawer': true,
                    'icon': 'mdi-counter',
                    roles: ['administrator'],
                    sort: 3999
                },
            },

        ],
    },
    {
        path: '/logout',
        name: '<i class="mdi mdi-logout"></i>',
        component: Logout,
        meta: {
            'class': 'menuLogout',
            'style': 'font-size: 150%;',
            'show-in-nav': true,
            'icon': 'mdi-logout',
            sort: 4000
        },
    }
];

export function getAllRoutes() {
    return baseRoutes;
}

export function removeRouteByName(routeName: string): boolean {
    baseRoutes.forEach((item, index) => {
        if (item.name === routeName) {
            baseRoutes.splice(index, 1);
            return true;
        }
    });
    return false;
}

export function redirectRouteToBackend(routeName: string, add: boolean) {
    const route = baseRoutes.find(value => value.name === routeName);
    if (route === undefined) {
        return;
    }
    if (!route.meta) {
        route.meta = {};
    }
    if (add) {
        route.meta['redirect-to-backend'] = true;
    } else {
        delete route.meta['redirect-to-backend'];
    }
    const index = baseRoutes.findIndex((value => value.name === routeName));
    baseRoutes[index] = route;
    resetRouter();
}

export function addChildRoute(parentName: string, route: RouteConfig) {
    const routeExists = baseRoutes.find(value => value.name === parentName);
    if (routeExists === undefined) {
        return;
    }
    if (routeExists.children === undefined) {
        return;
    }
    const childRoute = routeExists.children.find(value => value.name === route.name);
    if (childRoute === undefined) {
        routeExists.children.push(route);
    } else {
        const index = routeExists.children.findIndex((value => value.name === route.name));
        routeExists.children[index] = route;
    }
    resetRouter();
}

export function removeChildRoute(parentName: string, routeName: string) {
    const routeExists = baseRoutes.find(value => value.name === parentName);
    if (routeExists === undefined) {
        return;
    }
    if (routeExists.children === undefined) {
        return;
    }
    const childRoute = routeExists.children.find(value => value.name === routeName);
    if (childRoute !== undefined) {
        const index = routeExists.children.findIndex((value => value.name === routeName));
        routeExists.children.splice(index, 1);
    }
    resetRouter();
}


export function addRoutes(routes: RouteConfig[]) {
    if (routes === null || routes.length == 0) {
        return;
    }
    routes.forEach(r => addRoute(r, true));
    resetRouter();
}

export function addRoute(route: RouteConfig, bulk?: boolean) {
    const routeExists = baseRoutes.find(value => value.name === route.name);
    if (routeExists === undefined) {
        baseRoutes.push(route);
        if (!bulk) {
            resetRouter();
        }
        return;
    }
    const index = baseRoutes.findIndex((value => value.name === route.name));
    baseRoutes[index] = route;
    if (!bulk) {
        resetRouter();
    }
}

const createRouter = () => new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: baseRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter();
    router.beforeResolve((to, from, next) => {
        if (Vue.prototype.$membersCardManagement && !window.location.hostname.includes('admin.') && to.name !== 'membership-pass') {
            next({name: 'membership-pass'})
        }

        if (to.meta && to.meta['redirect-to-backend']) {
            location.href = `${authentication.baseUrl}${to.path.slice(1)}`;
            return;
        }
        next();
    });
    (router as any).matcher = (newRouter as any).matcher // reset router
}

export default router;
